import { ColorsMap } from '../constants';

interface ChartTooltipContentProps {
  active?: boolean;
  payload?: Array<{
    type?: string;
    value?: number | string;
    dataKey?: string;
    name?: string;
    color?: string;
    fill?: string;
  }>;
  coordinate?: {
    x?: number;
    y?: number;
  };
}

export const ChartTooltipContent = ({
  active,
  payload,
  coordinate,
}: ChartTooltipContentProps) => {
  if (!active || !payload?.length || !coordinate) return null;

  // Filter to show only segments with actual values (non-zero, non-undefined)
  const validSegments = payload.filter(
    (item) =>
      item.type !== 'none' &&
      item.value !== undefined &&
      item.value !== null &&
      (typeof item.value === 'number' ? item.value > 0 : true)
  );

  if (validSegments.length === 0) return null;

  const showLabels = validSegments.length > 1;

  return (
    <div
      className='relative'
      style={{
        position: 'absolute',
        left: coordinate.x,
        top: coordinate.y ? coordinate.y + 20 : undefined,
        transform: 'translateX(-50%)',
      }}
    >
      {/* Upward arrow */}
      <div
        className='absolute left-1/2 -translate-x-1/2 bottom-full w-0 h-0'
        style={{
          borderLeft: '6px solid transparent',
          borderRight: '6px solid transparent',
          borderBottom: '6px solid #f7f5fb',
        }}
      />
      <div className='bg-primary-50 rounded-lg py-2 px-3 text-[13px] shadow-xl'>
        <div className='flex flex-col gap-1'>
          {validSegments.map((item) => {
            const dataKey = item.dataKey as string;
            const color = ColorsMap[dataKey] || item.color || item.fill;

            return (
              <div
                key={item.dataKey}
                className='text-gray-1000 font-mono font-medium tabular-nums flex items-center gap-2'
              >
                {showLabels && color && (
                  <div
                    className='w-2 h-2 rounded-full shrink-0'
                    style={{ backgroundColor: color }}
                  />
                )}
                {showLabels && (
                  <span className='capitalize'>
                    {item.dataKey || item.name}:
                  </span>
                )}
                <span>
                  {typeof item.value === 'number'
                    ? item.value.toLocaleString()
                    : item.value}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
